import { navItems } from '@/mocks/gossip';

export default function Footer() {
  return (
    <footer id="contact" className="bg-background-200">
      {/* 联系区 */}
      <div className="mx-auto max-w-[1280px] px-4 pt-14 pb-8 md:px-6 md:pt-16">
        <div className="flex flex-col gap-8 rounded-lg border border-background-200/80 bg-background-50 p-6 md:p-8 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              关于「吃瓜最新」
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              我们是专注对事件素材进行归集、核验与梳理的媒体站点。坚持所有材料标注核验状态，
              用「时间线 + 声纹 + 影像」等基础手段帮助读者区分实锤与猜测，理性看待每一条新证据。
            </p>
          </div>
          <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
            <a
              href="mailto:hello@melonbuzz.example"
              rel="nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-mail-line" />
              hello@melonbuzz.example
            </a>
            <a
              href="#tougao"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" />
              我要投稿
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-quill-pen-fill text-sm" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">吃瓜最新</span>
            </div>
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-foreground-600">
              新实锤、新证据、新截图持续上线。以可核验的方式还原真相，做你的冷静吃瓜伙伴。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-500 uppercase">
              快速导航
            </h3>
            <ul className="mt-3 space-y-2">
              {navItems.map((n) => (
                <li key={n.key}>
                  <a
                    href={`#${n.key}`}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-500 uppercase">
              投稿与帮助
            </h3>
            <ul className="mt-3 space-y-2">
              <li>
                <a href="#tougao" className="text-sm text-foreground-700 hover:text-primary-700">
                  匿名投稿入口
                </a>
              </li>
              <li>
                <a href="#wenda" className="text-sm text-foreground-700 hover:text-primary-700">
                  核验流程说明
                </a>
              </li>
              <li>
                <a href="#wenda" className="text-sm text-foreground-700 hover:text-primary-700">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#changjing" className="text-sm text-foreground-700 hover:text-primary-700">
                  鉴别方法科普
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-semibold tracking-wide text-foreground-500 uppercase">
              内容声明
            </h3>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              本站内容均基于公开素材整理与核验，所有材料标注来源与状态。我们倡导理性吃瓜，
              反对传播未经证实的谣言与泄露他人隐私。未经授权请勿转载原始素材。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜最新 · Melon Buzz. 仅作为示例站点展示，请联系站务获取更多信息。
          </p>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-shield-check-line" />
              素材均标注核验状态
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}